import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api";

/* "Set up two-step verification" — for someone whose role requires it but who signed in before
   it was switched on (Salem 2026-10-01). They'd be made to set it up at their next sign-in
   anyway; this lets them do it now. ✕ hides it until tomorrow. */
const KEY = "repiq_2fa_banner_hidden";

export default function TwoStepBanner({ user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(KEY) === new Date().toISOString().slice(0, 10); } catch { return false; }
  });
  const owed = !!(user && user.mfa_required && !user.mfa_enabled);
  const [doneNow, setDoneNow] = useState(false);
  // The stored user can be stale (set up a minute ago on the Account page): ask once per page.
  useEffect(() => {
    if (!owed || hidden) return;
    api.get("/api/auth/mfa").then((s) => setDoneNow(!!s.enabled || !s.required)).catch(() => {});
  }, [owed, hidden, location.pathname]);
  if (!owed || doneNow || hidden || location.pathname === "/account") return null;
  const hide = () => {
    try { localStorage.setItem(KEY, new Date().toISOString().slice(0, 10)); } catch { /* ignore */ }
    setHidden(true);
  };
  return (
    <div style={{
      background: "color-mix(in srgb, var(--accent) 10%, var(--surface))",
      borderBottom: "2px solid var(--accent)", padding: "8px 16px",
      display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", fontSize: 12.5,
    }}>
      <span style={{ fontSize: 16 }}>🔐</span>
      <span style={{ flex: 1, minWidth: 260 }}>
        <b>Your role now needs two-step verification.</b>
        <span className="muted"> Set it up now — it takes a minute — or you'll be asked at your next sign-in.</span>
      </span>
      <button className="btn btn-primary btn-sm" onClick={() => navigate("/account#security")}>Set it up</button>
      <button className="btn btn-ghost btn-sm" title="Hide until tomorrow" onClick={hide}>✕</button>
    </div>
  );
}
